import { render } from "./FieldBuilder.vue?vue&type=template&id=bc3e67bc&scoped=true"
import script from "./FieldBuilder.vue?vue&type=script&lang=js"
export * from "./FieldBuilder.vue?vue&type=script&lang=js"

import "./FieldBuilder.vue?vue&type=style&index=0&id=bc3e67bc&scoped=true&lang=css"

import exportComponent from "../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc3e67bc"]])

export default __exports__